import(/* webpackMode: "eager" */ "/home/u461686465/domains/anetthorvath.com/public_html/.builds/source/website_project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u461686465/domains/anetthorvath.com/public_html/.builds/source/website_project/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u461686465/domains/anetthorvath.com/public_html/.builds/source/website_project/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u461686465/domains/anetthorvath.com/public_html/.builds/source/website_project/src/components/ui/AppImage.tsx");
